import React, { useState } from 'react'
import {
  AppBar,
  Toolbar,
  Grid,
  Button,
  SwipeableDrawer,
  Avatar,
  Menu,
  MenuItem,
  styled
} from '@mui/material'
import useScrollTrigger from '@mui/material/useScrollTrigger'
import { useTheme } from '@mui/styles'
import { Link, useHistory } from 'react-router-dom'
import logo from '../../assets/logo.png'
import useMediaQuery from '@mui/material/useMediaQuery'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'

const disabledColor = '#b3b3b3'

const Logo = styled('img')({
  height: '4em',
  background: 'transparent',
  color: 'white',
})

const LogoContainer = styled(Button)({
  padding: 0,
  '&:hover': {
    backgroundColor: 'transparent',
  },
})

const RowContainer = styled(Grid)(({ theme }) => ({
  paddingLeft: '2em',
  paddingRight: '2em',
  [theme.breakpoints.up('md')]: {
    paddingLeft: '4em',
    paddingRight: '4em',
  },
}))

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 1,
  backgroundColor: 'white',
}))

const StyledIconButton = styled(IconButton)({
  marginLeft: 'auto',
  '&:hover': {
    backgroundColor: 'transparent',
  },
})

const StyledMenuIcon = styled(MenuIcon)({
  height: '50px',
  width: '50px',
  color: '#2f1700',
})

function ElevationScroll(props) {
  const { children } = props

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  })

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  })
}

const TeacherLoggedInNav = ({
  user,
  profileTeacher,
  logout,
  cldTeacherImageAvatar,
}) => {
  const [openDrawer, setOpenDrawer] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const history = useHistory()
  const theme = useTheme()
  const matchesSM = useMediaQuery(theme.breakpoints.up('sm'))
  const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)

  const handleClose = () => {
    setAnchorEl(null)
  }

  const onMouseOverHandler = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const onClickLogOutDrawerHandler = () => {
    logout()
    setOpenDrawer(false)
  }

  const onClickContactUsDrawerHandler = () => {
    history.push('/contact-us')
    setOpenDrawer(false)
  }

  const onClickOrderManagerDrawerHandler = () => {
    history.push('/teachers/booked-lessons-manager')
    setOpenDrawer(false)
  }

  const logoutHandler = () => {
    logout()
    setAnchorEl(null)
    history.push('/')
  }

  const tabsTeacherLoggedIn = (
    <Grid item container alignItems="center">
      {user && user.role === 'teacher' && (
        <Grid item>
          <Button
            component={Link}
            to="/teachers/booked-lessons-manager"
            variant="text"
            disabled={!profileTeacher}
            sx={{
              color: profileTeacher ? '#555' : disabledColor,
              textTransform: 'none',
              marginRight: '1.5em',
            }}
          >
            Lesson management
          </Button>
        </Grid>
      )}

      {user && user.role === 'teacher' && (
        <Grid item>
          <Button
            component={Link}
            to="/contact-us"
            variant="text"
            sx={{
              color: '#555',
              textTransform: 'none',
              marginRight: '1.5em',
            }}
          >
            Contact us
          </Button>
        </Grid>
      )}

      <Grid item>
        <Button
          aria-controls="simple-menu"
          aria-haspopup="true"
          onMouseOver={onMouseOverHandler}
        >
          <Avatar
            style={{ width: '3em', height: '3em', borderRadius: '50%' }}
            src={
              user &&
              profileTeacher &&
              profileTeacher.teacherAvatar &&
              cldTeacherImageAvatar &&
              user.role === 'teacher' &&
              cldTeacherImageAvatar
            }
            alt="image-avatar"
          />
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          MenuListProps={{
            onMouseLeave: handleClose,
          }}
          elevation={0}
          style={{ zIndex: 1302 }}
          classes={{
            paper: {
              backgroundColor: theme.palette.common.blue,
              color: 'white',
              borderRadius: '0px',
            }
          }}
        >
          {user && user.role === 'teacher' && (
            <MenuItem
              component={Link}
              classes={{
                root: {
                  ...theme.typography.tab,
                  opacity: 0.7,
                  color: '#555',
                  '&:hover': {
                    opacity: 1,
                    color: '#555',
                  },
                }
              }}
              disabled={!profileTeacher}
              onClick={handleClose}
              to="/teachers/booked-lessons-manager"
            >
              Lesson management
            </MenuItem>
          )}

          <MenuItem
            classes={{
              root: {
                ...theme.typography.tab,
                opacity: 0.7,
                color: '#555',
                '&:hover': {
                  opacity: 1,
                  color: '#555',
                },
              }
            }}
            onClick={logoutHandler}
          >
            {user && user.role === 'teacher' && 'Log out'}
          </MenuItem>
        </Menu>
      </Grid>
    </Grid>
  )

  const drawer = (
    <>
      <SwipeableDrawer
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        onOpen={() => setOpenDrawer(true)}
        style={{ width: '14em' }}
      >
        <Grid
          container
          direction="column"
          alignItems="flex-end"
          style={{ width: '14em', paddingTop: '7em', minHeight: '100vh', backgroundColor: theme.palette.primary.main }}
        >
          <Grid item>
            <Button
              onClick={onClickOrderManagerDrawerHandler}
              style={{
                color: 'white',
                textTransform: 'none',
                marginRight: '1.5em',
              }}
              variant="text"
            >
              Order manager
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="text"
              onClick={onClickContactUsDrawerHandler}
              style={{
                color: 'white',
                textTransform: 'none',
                marginRight: '1.5em',
              }}
            >
              Contact us
            </Button>
          </Grid>

          <Grid item>
            <Button
              variant="text"
              onClick={onClickLogOutDrawerHandler}
              style={{
                color: 'white',
                textTransform: 'none',
                marginRight: '1.5em',
              }}
            >
              Log out
            </Button>
          </Grid>
        </Grid>
      </SwipeableDrawer>
      <StyledIconButton
        onClick={() => setOpenDrawer(!openDrawer)}
        disableRipple
        size="large">
        <StyledMenuIcon />
      </StyledIconButton>
    </>
  )

  return (
    <ElevationScroll>
      <StyledAppBar position="fixed">
        <Toolbar variant="dense" disableGutters>
          <RowContainer
            container
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <LogoContainer
                component={Link}
                to="/"
                disableRipple
              >
                {logo && (
                  <Logo alt="company-logo" src={logo} />
                )}
              </LogoContainer>
            </Grid>
            <Grid item>{matchesSM ? tabsTeacherLoggedIn : drawer}</Grid>
          </RowContainer>
        </Toolbar>
      </StyledAppBar>
    </ElevationScroll>
  );
}

export default TeacherLoggedInNav
